module.exports = __webpack_public_path__ + "img/55.8.TSS.584d6f4d.png";